import React, { useContext, useState, useEffect } from "react";
import ToolBarItem from "../../../components/Toolbar/ToolBarItem";
import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function ToolBarMenu(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();
  
  useEffect(() => {
    
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    
    newStyle["top"] = "0";
    newStyle["left"] = "0";
    newStyle["width"] = "100%";
    //newStyle["backgroundColor"] = "transparent";
    return newStyle;
  };
 

  const getNode = (nodes, parentId) => {

    let node = nodes.map(child => {
      if (child.id == parentId)
        return child
      else
        return getNode(child.childs, parentId)
    })
    
    return node.flat(Infinity)
  }
 
  return (
    <div  draggable={props.draggable}
      onDragStart={(e) => props.onDragStart(e)}
      id={props.data.id}
      style={getContainerStyle()}
      onClick={props.onClick}>
      
    </div>
  );
}
